'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MessagesTemplates = require('./MessagesTemplates.scss');

var _MessagesTemplates2 = _interopRequireDefault(_MessagesTemplates);

var _reactRedux = require('react-redux');

var _account = require('redux/modules/account');

var _messages = require('redux/modules/messages');

var _auth = require('redux/modules/auth');

var _reduxConnect = require('redux-connect');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _components = require('components');

var _reactRouter = require('react-router');

var _themeEnabled = require('helpers/themeEnabled');

var _translations = require('translations');

var _translations2 = _interopRequireDefault(_translations);

var _Allow = require('../../containers/Allow/Allow');

var _Allow2 = _interopRequireDefault(_Allow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md = {
  arrowBack: require('react-icons/lib/md/arrow-back')
};

var MessagesTemplates = (_dec = (0, _reduxConnect.asyncConnect)([{
  key: 'account',
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var state = getState();
    if (!state.account.data.reach) {
      return dispatch((0, _account.getAccount)());
    }
    return null;
  }
}, {
  key: "auth",
  promise: function promise(_ref2) {
    var _ref2$store = _ref2.store,
        dispatch = _ref2$store.dispatch,
        getState = _ref2$store.getState;

    if (!(0, _auth.isLoaded)(getState())) {
      return dispatch((0, _auth.load)());
    }
    return null;
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    account: state.auth.current_account
  };
}, { getAccount: _account.getAccount, getMessagesTemplates: _messages.getMessagesTemplates }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(MessagesTemplates, _React$Component);

  function MessagesTemplates(props) {
    (0, _classCallCheck3.default)(this, MessagesTemplates);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MessagesTemplates.__proto__ || (0, _getPrototypeOf2.default)(MessagesTemplates)).call(this, props));

    _this.state = {
      account_uid: _this.props.account.account_uid,
      table: true,
      title: (0, _translations2.default)('TEMPLATES'),
      account: _this.props.account,
      templates: null,
      selected_template: null
    };
    return _this;
  }

  (0, _createClass3.default)(MessagesTemplates, [{
    key: 'componentDidMount',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var templatesList;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.getMessagesTemplates(this.state.account_uid);

              case 2:
                templatesList = _context.sent;

                this.setState({ templates: templatesList });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref3.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'renderSearch',
    value: function renderSearch() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: _MessagesTemplates2.default.search },
        _react2.default.createElement('input', { className: _MessagesTemplates2.default.input,
          type: 'text', placeholder: (0, _translations2.default)('SEARCH PLACEHOLDER'),
          onChange: function onChange(e) {
            return _this2.handleSearch(e);
          }
        })
      );
    }
  }, {
    key: 'handleSearch',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(event) {
        var templatesList;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.props.getMessagesTemplates(this.state.account_uid, event.target.value);

              case 2:
                templatesList = _context2.sent;

                this.setState({ templates: templatesList });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSearch(_x) {
        return _ref4.apply(this, arguments);
      }

      return handleSearch;
    }()
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      var _this3 = this;

      var isNewHidden = true;
      var isBackHidden = false;
      if (this.state.table) {
        isNewHidden = false;
        isBackHidden = true;
      }

      return _react2.default.createElement(
        'div',
        { className: _MessagesTemplates2.default.columnTitle },
        _react2.default.createElement(
          'div',
          { className: _MessagesTemplates2.default.icon, onClick: function onClick() {
              return _this3.back();
            } },
          _react2.default.createElement(md.arrowBack, { size: 20, color: '#FFF', hidden: isBackHidden })
        ),
        _react2.default.createElement(
          'div',
          { className: _MessagesTemplates2.default.title },
          this.state.title
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _Allow2.default,
            { permissions: ['channels:sms:template:create'] },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/messages/templates/new' },
              _react2.default.createElement(
                'button',
                { className: _MessagesTemplates2.default.newButton, hidden: isNewHidden },
                (0, _translations2.default)('NEW TEMPLATE')
              )
            )
          ),
          _react2.default.createElement(
            _Allow2.default,
            { permissions: ['channels:sms:template:create'] },
            ' ',
            _react2.default.createElement(
              _reactRouter.Link,
              { to: { pathname: '/messages/templates/report',
                  state: { templateInformation: this.state.selected_template } } },
              _react2.default.createElement(
                'button',
                { className: _MessagesTemplates2.default.newButton, hidden: isBackHidden },
                (0, _translations2.default)('REPORT')
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          this.renderSearch()
        )
      );
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      return _react2.default.createElement(
        'div',
        { className: _MessagesTemplates2.default.table },
        _react2.default.createElement(
          'table',
          { className: _MessagesTemplates2.default.tableContent },
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              { className: _MessagesTemplates2.default.trTitle },
              _react2.default.createElement(
                'td',
                { className: _MessagesTemplates2.default.nameTitle },
                (0, _translations2.default)('NAME')
              ),
              _react2.default.createElement(
                'td',
                { className: _MessagesTemplates2.default.dateTitle },
                (0, _translations2.default)('CREATED ON')
              ),
              _react2.default.createElement(
                _Allow2.default,
                { permissions: ['channels:sms:template:duplicate'] },
                _react2.default.createElement('td', { className: _MessagesTemplates2.default.duplicateTitle })
              )
            ),
            this.renderTableData()
          )
        )
      );
    }
  }, {
    key: 'renderTableData',
    value: function renderTableData() {
      if (this.state.templates != null) {
        return this.state.templates.map(function (template) {
          var id = template.id,
              name = template.name,
              created_on = template.created_on;

          return _react2.default.createElement(
            'tr',
            { key: id, className: _MessagesTemplates2.default.trContent },
            _react2.default.createElement(
              'td',
              { className: _MessagesTemplates2.default.tdName },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: { pathname: '/messages/templates/report',
                    state: { templateInformation: template } } },
                _react2.default.createElement(
                  'div',
                  { className: _MessagesTemplates2.default.font },
                  name
                )
              )
            ),
            _react2.default.createElement(
              'td',
              { className: _MessagesTemplates2.default.tdDate },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: { pathname: '/messages/templates/report',
                    state: { templateInformation: template } } },
                _react2.default.createElement(
                  'div',
                  { className: _MessagesTemplates2.default.font },
                  (0, _moment2.default)(created_on).format('YYYY-MM-DD')
                )
              )
            ),
            _react2.default.createElement(
              _Allow2.default,
              { permissions: ['channels:sms:template:duplicate'] },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: { pathname: '/messages/templates/duplicate',
                    state: { duplicateTemplateData: template } } },
                _react2.default.createElement(_components.Button, { name: 'Duplicar', className: _MessagesTemplates2.default.button })
              )
            )
          );
        });
      } else {
        return _react2.default.createElement(_components.Loading, { className: _MessagesTemplates2.default.loading });
      }
    }
  }, {
    key: 'renderVariables',
    value: function renderVariables() {
      if (this.state.selected_template.properties.variables != null) {
        return this.state.selected_template.properties.variables.map(function (variable) {
          return _react2.default.createElement(
            'li',
            null,
            variable
          );
        });
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      return this.renderTable();
    }
  }, {
    key: 'render',
    value: function render() {

      var classesTheme = (0, _themeEnabled.getThemeEnabledStyle)(_MessagesTemplates2.default);
      return _react2.default.createElement(
        'div',
        { className: classesTheme },
        _react2.default.createElement(
          'div',
          { className: _MessagesTemplates2.default.main },
          _react2.default.createElement(_reactHelmet2.default, { title: "SMS Templates" }),
          _react2.default.createElement(
            'div',
            { className: _MessagesTemplates2.default.body },
            _react2.default.createElement(
              'div',
              { className: _MessagesTemplates2.default.contentMain },
              this.renderTitle(),
              this.renderContent()
            )
          )
        )
      );
    }
  }]);
  return MessagesTemplates;
}(_react2.default.Component)) || _class) || _class);
exports.default = MessagesTemplates;
module.exports = exports['default'];